import { useEffect } from 'react';

export const usePrepareConfiguration = config => {
  const initDietId = Number(config.diet);
  const showSelect = config.showSelect === 'showSelect';
  const companyId = config.companyId;
  const height = config.height ? `${config.height}px` : 'initial';
  const path = config.path ? config.path : '';

  useEffect(() => {
    if (config?.primaryColor) {
      document.documentElement.style.setProperty(
        '--primary',
        config.primaryColor
      );
    }

    if (config?.secondaryColor) {
      document.documentElement.style.setProperty(
        '--secondary',
        config.secondaryColor
      );
    }

    document.getElementById('root-widget-menu').removeAttribute('data-config');
  }, [config]);

  return { initDietId, showSelect, companyId, height, path };
};
